import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {PermissionArea} from '../../enums/permission-area.enum';
import {IconCode} from '../../enums/icon-code.enum';

@Injectable()
export class NavUserFactory extends NavFactory {
    protected static baseUserPath = '/admin/partner';
    protected static items = [
        {
            code: NavItemCodes.USER_MANAGEMENT,
            icon: IconCode.USER_MANAGEMENT,
            label: 'NAV.USER.LABEL',
            description: 'NAV.USER.DESC',
            path: ({partnerId, localizationId = ''}) => {
                return localizationId
                    ? [
                        NavUserFactory.baseUserPath,
                        partnerId,
                        'localization',
                        localizationId,
                        'users'
                    ]
                    : [
                        NavUserFactory.baseUserPath,
                        partnerId,
                        'localizations',
                        'users'
                    ];
            },
            permissionArea: PermissionArea.USER_MANAGEMENT
        },
        {
            code: NavItemCodes.USER_ADD,
            icon: IconCode.USER_ADD,
            label: 'USER.ADD',
            description: 'USER.ADD',
            path: ({partnerId, localizationId = ''}) => {
                return localizationId
                    ? [
                        NavUserFactory.baseUserPath,
                        partnerId,
                        'localization',
                        localizationId,
                        'users',
                        'add'
                    ]
                    : [
                        NavUserFactory.baseUserPath,
                        partnerId,
                        'localizations',
                        'users',
                        'add'
                    ];
            }
        },
        {
            code: NavItemCodes.USER_EDIT,
            icon: IconCode.USER_EDIT,
            label: 'USER.EDIT',
            description: 'USER.EDIT',
            path: ({partnerId, localizationId, userId}) => {
                return [
                    NavUserFactory.baseUserPath,
                    partnerId,
                    'localization',
                    localizationId,
                    'users',
                    userId,
                    'edit'
                ];
            }
        },
        {
            code: NavItemCodes.USER_ACTIVATE,
            icon: IconCode.USER_ACTIVATE,
            label: 'USER.ACTIVATE',
            description: 'USER.ACTIVATE',
        },
        {
            code: NavItemCodes.USER_DEACTIVATE,
            icon: IconCode.USER_DEACTIVATE,
            label: 'USER.DEACTIVATE',
            description: 'USER.DEACTIVATE',
        },
        {
            code: NavItemCodes.USER_PASS_RESET,
            icon: IconCode.USER_PASS_RESET,
            label: 'USER.PASS_RESET',
            description: 'USER.PASS_RESET',
        },
    ];
}
